<template>
    <q-layout data-testid="report-manager" class="q-pa-lg">
      <q-card class="fit">
        <q-card-section class="q-py-xs">
          <div class="report-title">
            {{reportTitle || name}}
          </div>
        </q-card-section>
        <q-card-section>
          <div class="row">
            <JtDynamicForm
              data-testid="form"
              ref="form"
              :inputs="form.inputs"
              :model="form.dadosForm"
              :relacionamentos="form.relacionamentos"
              :interface="form.nmInterface"
              @on-select-change="onSelectChangeHandler"
            />
          </div>
        </q-card-section>
      </q-card>
      <div class="row btn-container q-gutter-md justify-center">
        <q-btn
          data-testid="gerar-btn"
          color="blue-grey-3"
          class="col-5"
          @click="onClear"
        >
          {{ $gettext('CLEAN') }}
        </q-btn>
        <q-btn
          data-testid="gerar-btn"
          color="primary"
          class="col-5"
          @click="onGenerateReportClick"
        >
          {{ $gettext('GENERATE') }}
        </q-btn>
      </div>
      <JtDocsViewer

        :src="fileSrc"
        :title="reportTitle || name"
        :pdf="reportFormat.pdf"
        :xls="reportFormat.xls"
        ref="reportModal"
      />
    </q-layout>
  </template>
<script>
import { Vue, Component } from 'vue-property-decorator'
import { JtCrud, JtDataTable, JtDocs, JtDynamicForm } from 'jtech-webcomps'
import { repository } from 'jtech'

const { page, pageTable, CrudLayoutSearch } = JtCrud

const FORMA_GERACAO = {
  ONLINE: 1,
  AGENDAMENTO: 2
}

const FORMATO_RELATORIO = {
  PDF: 1,
  HTML: 2,
  EXCEL: 3,
  CSV: 7
}

const setOnlyThisAttributeAsTrue = (obj, attrName) => {
  const newObject = { ...obj }
  for (const key in obj) {
    newObject[key] = attrName === key
  }
  return newObject
}

  @Component({
    components: {
      JtDynamicForm,
      JtDocsViewer: JtDocs.JtDocsViewer
    },
    props: {
      nmInterface: {
        type: String,
        required: true
      },
      interface: {
        type: String,
        required: true
      },
      dadosTela: {
        type: Array,
        default: () => []
      },
      reportTitle: {
        type: String
      },
      name: {
        type: String
      }
    }
  })
class InvoiceReport extends Vue {
    reportFormat = {}

    reportGenerationFormat = {
      online: true,
      scheduling: false
    }

    dadosTelaFromRepository = []
    fileSrc = null

    async beforeMount () {
      if (!this.dadosTela.length) { this.dadosTelaFromRepository = await this.__getDisplayData() }
    }

    get action () {
      return this.nmInterface || this.interface
    }

    setReportFormat () {
      this.reportFormat = { pdf: false, html: false, xls: false, csv: false }

      const tipoRel = this.$refs.form.model.relFormatoRelatorioCombo

      const formatMapping = {
        50300001: 'pdf',
        50300002: 'xls',
        50300003: 'csv'
      }

      if (formatMapping[tipoRel]) {
        this.reportFormat[formatMapping[tipoRel]] = true
      } else {
        this.reportFormat.csv = true
      }
    }

    async onGenerateReportClick () {
      this.reportFormat = {}
      this.setReportFormat()
      try {
        if (!this.$refs.form.isValidForm()) return
        if (!this.isSelfResolvable) {
          this.$emit('generate', {
            dadosForm: this.form.dadosForm,
            nmInterface: this.form.nmInterface
          })
        }

        const resolveLogicResult = await this.$jt.repository.resolveLogic(
          this.action,
          this.form.dadosForm
        )

        await this.__whenGenerationFormatIsOnline(resolveLogicResult)
        this.__whenGenerationFormatIsScheduling()
      } catch (error) {
        console.error(error)
      }
    }

    onSelectChangeHandler (value) {
      switch (value.input.model) {
        case 'relFormatoRelatorio':
          this.__reportFormatHandler(value.selectedValue)
          break
        case 'relFormaGeracao':
          this.__reportGenerationFormatHandler(value.selectedValue)
          break
        default:
          break
      }
    }

    onClear () {
      this.$refs.form.resetForm()
    }

    get isSelfResolvable () {
      return this.dadosTela.length === 0
    }

    get form () {
      return this.isSelfResolvable
        ? this.computedDadosTelaFromRepository
        : this.computedDadosTela
    }

    get reportFileExtension () {
      let fileExtension = ''
      for (const key in this.reportFormat) {
        if (this.reportFormat[key] === true) {
          fileExtension = key
        }
      }
      return fileExtension
    }

    get computedDadosTela () {
      return Array.isArray(this.dadosTela) && this.dadosTela.length
        ? this.dadosTela[0]
        : {}
    }

    get computedDadosTelaFromRepository () {
      return Array.isArray(this.dadosTelaFromRepository) &&
        this.dadosTelaFromRepository.length
        ? this.dadosTelaFromRepository[0]
        : {}
    }

    __reportFormatHandler (value) {
      switch (value) {
        case FORMATO_RELATORIO.PDF:
          this.reportFormat = setOnlyThisAttributeAsTrue(this.reportFormat, 'pdf')
          break
        case FORMATO_RELATORIO.HTML:
          this.reportFormat = setOnlyThisAttributeAsTrue(
            this.reportFormat,
            'html'
          )
          break
        case FORMATO_RELATORIO.EXCEL:
          this.reportFormat = setOnlyThisAttributeAsTrue(this.reportFormat, 'xls')
          break
        default:
          break
      }
    }

    __reportGenerationFormatHandler (value) {
      switch (value) {
        case FORMA_GERACAO.ONLINE:
          this.reportGenerationFormat = setOnlyThisAttributeAsTrue(
            this.reportGenerationFormat,
            'online'
          )
          break
        case FORMA_GERACAO.AGENDAMENTO:
          this.reportGenerationFormat = setOnlyThisAttributeAsTrue(
            this.reportGenerationFormat,
            'scheduling'
          )
          break
        default:
          break
      }
    }

    __getDisplayData () {
      return this.$jt.repository.resolve(this.action)
    }

    async __whenGenerationFormatIsOnline ({ nmArquivo }) {
      try {
        if (!this.reportGenerationFormat.online) return Promise.resolve()
        const result = await this.$jt.repository.downloadFile(
          nmArquivo,
          this.reportFileExtension
        )
        this.fileSrc = this.reportFormat.html
          ? await result.text()
          : URL.createObjectURL(result)

        this.$nextTick(() => {
          const actionMapping = {
            xls: () => this.__downloadFile(this.fileSrc, this.action, '.xls'),
            csv: () => this.__downloadFile(this.fileSrc, this.action, '.csv'),
            html: () => this.$refs.htmlReportModal.show(),
            default: () => this.$refs.reportModal.show()
          }
          const format = Object.keys(this.reportFormat).find(key => this.reportFormat[key]);

          (actionMapping[format] || actionMapping.default)()
        })
        return Promise.resolve()
      } catch (error) {
        return Promise.reject(error)
      }
    }

    __whenGenerationFormatIsScheduling () {
      if (!this.reportGenerationFormat.scheduling) return
      this.$jt.messageBox.success(this.$gettext('REPORT_SCHEDULING_SUCCESS'))
    }

    __downloadFile (fileSrc, fileName = 'downloaded_file', extension = '.xls') {
      const link = document.createElement('a')
      link.style = 'display: none'
      link.download = `${fileName}${extension}`
      link.href = fileSrc
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    }
  }
export default InvoiceReport
</script>
<style lang="stylus" scoped>
.report-title {
  font-weight: 500;
  font-size: 1.3em;
  margin-top: 5px;
  border-bottom: 1px solid #e0e0e0;
}
.btn-container {
  margin-top: 30px;
}
</style>
